import React, { useEffect, useRef, useState } from "react";
import CloudStorage from "../../../../../../../../CloudStorage/CloudStorage";
import { useDispatch } from "react-redux";
import { AproveJobtime } from "../../../../../../../../redux/job/action";
import PostNotFound from "../../../../../../../CustomComponents/AllLoader/PostNotFound";
import { getDateFormate } from "../../../../../../../Common/AllDateTimeReleventFormate";
import moment from "moment";

export default function JobPendingSheetLists({
  proposalmilestones,
  posts,
  setTimeData,
}) {
  const [show, setShow] = useState(0);
  const [loading, setLoading] = useState(false);
  const [buttonactive, setButtonActive] = useState(0);
  const dispatch = useDispatch();

  const aprroveJobTime = (id) => {
    const data = {
      type: "1",
      job_time_id: id,
      status: "1",
      posts_id: posts?.id,
    };
    dispatch(AproveJobtime(data, setLoading));
  };

  const rejectJobTime = (id) => {
    const data = {
      type: "1",
      job_time_id: id,
      status: "2",
      posts_id: posts?.id,
    };
    dispatch(AproveJobtime(data, setLoading));
  };

  const handleClick = (id) => {
    setButtonActive((prev) => (prev == id ? 0 : id));
  };

  const settimedata = (item) => {
    window.scrollTo(0, 120);
    setTimeData(item);
  };

  const deleteentry = (id) => {
    const data = {
      type: "1",
      job_time_id: id,
      status: "3",
      posts_id: posts?.id,
    };
    dispatch(AproveJobtime(data, setLoading));
  };

  const Converttime12 = (time24) => {
    const [hour, minute] = time24.split(":");
    const date = new Date();
    date.setHours(hour, minute, 0, 0);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setButtonActive(0); // Close all dropdowns
      }
    };

    if (buttonactive !== 0) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [buttonactive]);

  const processTimesheets = () => {
    const allPending = [
      ...(proposalmilestones?.job_time_thisweek || []),
      ...(proposalmilestones?.job_time_pending || [])
    ];

    const isMonthly = posts?.hiring_type == 4;
    const now = moment();

    let bucket1 = []; // This week / This month
    let bucket2 = []; // Last week / Last month

    allPending.forEach(item => {
      const itemDate = moment(item.date);
      if (isMonthly) {
        if (itemDate.isSame(now, 'month')) {
          bucket1.push(item);
        } else {
          bucket2.push(item);
        }
      } else {
        // Weekly logic
        const startOfThisWeek = now.clone().startOf('week');
        if (itemDate.isSameOrAfter(startOfThisWeek)) {
          bucket1.push(item);
        } else {
          bucket2.push(item);
        }
      }
    });

    return { bucket1, bucket2 };
  };

  const sumDurations = (items) => {
    let totalSeconds = 0;
    items.forEach(item => {
      if (item.duration) {
        const parts = item.duration.split(':').map(Number);
        if (parts.length === 3) {
          totalSeconds += parts[0] * 3600 + parts[1] * 60 + parts[2];
        } else if (parts.length === 2) {
          totalSeconds += parts[0] * 3600 + parts[1] * 60;
        }
      }
    });
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };

  const { bucket1, bucket2 } = processTimesheets();
  const bucket1Total = sumDurations(bucket1);
  const bucket2Total = sumDurations(bucket2);

  return (
    <>
      <div>
        <div className="week-section">
          <div className="tabcont-heading">
            <h5>{posts?.hiring_type == 4 ? "This month" : "This week"}</h5>
            <h5>
              {posts?.hiring_type == 4 ? "Monthly Total" : "Weekly Total"} : {bucket1Total}
            </h5>
          </div>
        </div>
        {Array.isArray(bucket1) &&
          bucket1?.length > 0 ? (
          bucket1?.map((item, index) => (
            <div className="week-section" key={index}>
              <div className="week-collpase">
                <h6 className="" onClick={() => {
                  setShow(prev => {
                    if (prev == item.id) return 0;       // clicking same ID → reset
                    return item.id;                       // clicking new → set new ID
                  });
                }}>
                  {getDateFormate(item?.date)}
                  <span>Total : {item?.duration}</span>
                </h6>
                <div className="col-md-12 bg-white pt-2 mock-head" style={{ borderBottom: "2px solid gray" }}>
                  <div className="row align-items-center">
                    <div className="col-md-3">
                      <h6>Description</h6>
                    </div>
                    <div className="col-md-3 mockup-center d-flex align-items-center justify-content-between">
                      <h6>Start Time</h6>
                      <h6>End Time</h6>
                    </div>
                    <div className="col-md-2 mockup-right d-flex align-items-center justify-content-between">
                      <h6>Total Worked Hours</h6>
                    </div>

                    <div className="col-md-4 mockup-right d-flex align-items-center justify-content-between">
                      <h6>Status</h6>
                      <h6>Action</h6>
                    </div>
                  </div>
                </div>
                {Array.isArray(item?.job_time) &&
                  item?.job_time?.length > 0 &&
                  item?.job_time?.map((item1, index1) => (
                    <>
                      <div
                        style={{ borderBottom: "2px solid gray" }}
                        className={`mockup-row ${show == item1.id ? "show" : ""}`}
                        key={index1}
                      >
                        <div className="mockup">
                          <div className="col-md-12">
                            <div className="row align-items-center">
                              <div className="col-md-3">
                                <p>{item1?.message}</p>
                              </div>
                              <div className="col-md-3 mockup-center">
                                <p>{Converttime12(item1?.start_time)}</p>
                                <p>{Converttime12(item1?.end_time)}</p>
                              </div>
                              {posts?.is_mine == 1 ? (
                                <>
                                  <div className="col-md-2 mockup-right">
                                    <h5>{item1?.duration}</h5>
                                  </div>
                                  {item1?.status == 0 ? (
                                    <div className="col-md-4 mockup-right d-flex align-items-center justify-content-between">
                                      <p className="pending">Pending</p>
                                      <div className="d-flex aling-items-center" style={{ columnGap: '10px' }}>
                                        <a>
                                          <img
                                            onClick={() => rejectJobTime(item1?.id)}
                                            src={`${CloudStorage.cloudurl}/Assets/Images/common/circleclose-icon.svg`}
                                            alt=""
                                          />
                                        </a>
                                        <a>
                                          <img
                                            onClick={() =>
                                              aprroveJobTime(item1?.id)
                                            }
                                            src={`${CloudStorage.cloudurl}/Assets/Images/common/circle-tick.svg`}
                                            alt=""
                                          />
                                        </a>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="col-md-4 mockup-right d-flex align-items-center justify-content-between">
                                      {item1?.status == 2 ? (
                                        <p
                                          style={{
                                            background: "orange",
                                            color: "#fff",
                                          }}
                                          className="pending"
                                        >
                                          Rejected
                                        </p>
                                      ) : item1?.status == 3 ? (
                                        <p
                                          style={{
                                            background: "red",
                                            color: "#fff",
                                          }}
                                          className="pending"
                                        >
                                          Deleted
                                        </p>
                                      ) : (
                                        <p
                                          style={{
                                            background: "green",
                                            color: "#fff",
                                          }}
                                          className="pending"
                                        >
                                          Approved
                                        </p>
                                      )}
                                    </div>
                                  )}
                                </>
                              ) : (
                                <>
                                  {/* <a className="calendar-icon">
                                    <img
                                      src={`${CloudStorage.cloudurl}/Assets/Images/common/calendar.svg`}
                                      alt=""
                                    />
                                  </a> */}
                                  <div className="col-md-2 mockup-right">
                                    <h5 style={{ minWidth: 'max-content' }}>{item1?.duration}</h5>
                                  </div>
                                  {item1?.status == 0 ? (
                                    <div className="col-md-4 mockup-right d-flex align-items-center justify-content-between">
                                      <p className="pending">Pending</p>
                                      <div
                                        ref={buttonactive === item1?.id ? dropdownRef : null}
                                        className={`dropdown ${buttonactive === item1?.id ? "active" : ""}`}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleClick(item1?.id);
                                        }}
                                      >
                                        <button className="btn">
                                          <img
                                            src={`${CloudStorage.cloudurl}/Assets/Images/common/dots-vertical.svg`}
                                            alt=""
                                          />
                                        </button>
                                        <div className="dropdown-content">
                                          <a onClick={(e) => {
                                            e.stopPropagation();
                                            settimedata(item1);
                                            setButtonActive(0);
                                          }}>
                                            Duplicate
                                          </a>
                                          <a
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              deleteentry(item1?.id);
                                              setButtonActive(0);
                                            }}
                                            className="delete"
                                          >
                                            Delete Entry
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="col-md-4 mockup-right d-flex align-items-center justify-content-between">
                                      {item1?.status == 2 ? (
                                        <p
                                          style={{
                                            background: "orange",
                                            color: "#fff",
                                          }}
                                          className="pending"
                                        >
                                          Rejected
                                        </p>
                                      ) : item1?.status == 3 ? (
                                        <p
                                          style={{
                                            background: "red",
                                            color: "#fff",
                                          }}
                                          className="pending"
                                        >
                                          Deleted
                                        </p>
                                      ) : (
                                        <p
                                          style={{
                                            background: "green",
                                            color: "#fff",
                                          }}
                                          className="pending"
                                        >
                                          Approved
                                        </p>
                                      )}
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
              </div>
            </div>
          ))
        ) : (
          <PostNotFound title={`No pending timesheets found for ${posts?.hiring_type == 4 ? "this month" : "this week"}`} />
        )}
      </div>
      <div>
        <div className="week-section">
          <div className="tabcont-heading">
            <h5>{posts?.hiring_type == 4 ? "Last month" : "Last week"}</h5>
            <h5>
              {posts?.hiring_type == 4 ? "Monthly Total" : "Weekly Total"} : {bucket2Total}
            </h5>
          </div>
        </div>
        {Array.isArray(bucket2) &&
          bucket2?.length > 0 ? (
          bucket2?.map((item, index) => (
            <div className="week-section" key={index}>
              <div className="week-collpase">
                <h6 className="" onClick={() => setShow(item?.id)}>
                  {getDateFormate(item?.date)}
                  <span>Total : {item?.duration}</span>
                </h6>
                {Array.isArray(item?.job_time) &&
                  item?.job_time?.length > 0 &&
                  item?.job_time?.map((item1, index1) => (
                    <div
                      style={{ borderBottom: "2px solid gray" }}
                      className={`mockup-row ${show == item1.id ? "show" : ""}`}
                      key={index1}
                    >
                      <div className="mockup">
                        <div className="col-md-12">
                          <div className="row align-items-center">
                            <div className="col-md-5">
                              <p>{item1?.message}</p>
                            </div>
                            <div className="col-md-3 mockup-center">
                              <p>{item1?.start_time}</p>
                              <p>{item1?.end_time}</p>
                            </div>
                            {posts?.is_mine == 1 ? (
                              <div className="col-md-2 mockup-right">
                                <h5>{item1?.duration}</h5>
                                {item1?.status == 0 ? (
                                  <>
                                    <p className="pending">Pending</p>
                                    <a>
                                      <img
                                        onClick={() => rejectJobTime(item1?.id)}
                                        src={`${CloudStorage.cloudurl}/Assets/Images/common/circleclose-icon.svg`}
                                        alt=""
                                      />
                                    </a>
                                    <a>
                                      <img
                                        onClick={() =>
                                          aprroveJobTime(item1?.id)
                                        }
                                        src={`${CloudStorage.cloudurl}/Assets/Images/common/circle-tick.svg`}
                                        alt=""
                                      />
                                    </a>
                                  </>
                                ) : (
                                  <>
                                    {item1?.status == 2 ? (
                                      <p
                                        style={{
                                          background: "orange",
                                          color: "#fff",
                                        }}
                                        className="pending"
                                      >
                                        Rejected
                                      </p>
                                    ) : item1?.status == 3 ? (
                                      <p
                                        style={{
                                          background: "red",
                                          color: "#fff",
                                        }}
                                        className="pending"
                                      >
                                        Deleted
                                      </p>
                                    ) : (
                                      <p
                                        style={{
                                          background: "green",
                                          color: "#fff",
                                        }}
                                        className="pending"
                                      >
                                        Approved
                                      </p>
                                    )}
                                  </>
                                )}
                              </div>
                            ) : (
                              <div className="col-md-2 mockup-right">
                                <a className="calendar-icon">
                                  <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/calendar.svg`}
                                    alt=""
                                  />
                                </a>
                                <h5 style={{ minWidth: 'max-content' }}>{item1?.duration}</h5>
                                {item1?.status == 0 ? (
                                  <>
                                    <p className="pending">Pending</p>
                                    <div
                                      ref={buttonactive === item1?.id ? dropdownRef : null}
                                      className={`dropdown ${buttonactive === item1?.id ? "active" : ""}`}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleClick(item1?.id);
                                      }}
                                    >
                                      <button className="btn">
                                        <img
                                          src={`${CloudStorage.cloudurl}/Assets/Images/common/dots-vertical.svg`}
                                          alt=""
                                        />
                                      </button>
                                      <div className="dropdown-content">
                                        <a onClick={(e) => {
                                          e.stopPropagation();
                                          settimedata(item1);
                                          setButtonActive(0);
                                        }}>
                                          Duplicate
                                        </a>
                                        <a
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            deleteentry(item1?.id);
                                            setButtonActive(0);
                                          }}
                                          className="delete"
                                        >
                                          Delete Entry
                                        </a>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    {item1?.status == 2 ? (
                                      <p
                                        style={{
                                          background: "orange",
                                          color: "#fff",
                                        }}
                                        className="pending"
                                      >
                                        Rejected
                                      </p>
                                    ) : item1?.status == 3 ? (
                                      <p
                                        style={{
                                          background: "red",
                                          color: "#fff",
                                        }}
                                        className="pending"
                                      >
                                        Deleted
                                      </p>
                                    ) : (
                                      <p
                                        style={{
                                          background: "green",
                                          color: "#fff",
                                        }}
                                        className="pending"
                                      >
                                        Approved
                                      </p>
                                    )}
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ))
        ) : (
          <PostNotFound title={`No pending timesheets found for ${posts?.hiring_type == 4 ? "last month" : "last week"}`} />
        )}
      </div>
    </>
  );
}